var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPullout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.95 18.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.83h-1V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1.83H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h1v7.97c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V9.86h1c.55 0 1-.45 1-1v-5c.02-.55-.42-1.01-.97-1.03H19zM15 5.8h-3.06v-2H15v2zM3 6.92h14v.71H3v-.71zM3 1h14v4.8h-1v-2c0-.55-.45-1-1-1h-3.06c-.55 0-1 .45-1 1v2H9.05v-2c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H3V1zm2 4.8v-2h3v2H5zM1 8.86v-5h1v5H1zm16 8.94H3V8.63h14v9.17zm2-8.94h-1v-5h1v5z",
    fill: "#1ab2c5"
  })));
}

export default SvgIconPullout;